import React from "react";
import { useRoutes, Outlet } from "react-router-dom";

import RequireAdmin from "./components/RequireAdmin";
import RequireRole from "./components/RequireRole";
import ImportAdsAdmin from "pages/ImportAdsAdmin";
// pages...
import SignInDealer from "pages/SignInDealer";
import NotFound from "pages/NotFound";
import Home from "pages/Home";
import RecivedOffersAdminCar from "pages/RecivedOffersAdminCar";
// dealer pages
import DashboredDealer from "pages/DashboredDealer";
import CarCatalogDealer from "pages/CarCatalogDealer";
import DealerProfile from "pages/DealerrProfil";
import OffersDealer from "pages/OffersDealer";
import NotificationsDealer from "pages/NotificationsDealer";
import RecivedOffersAdmin from "pages/RecivedOffersAdmin";
import BillingAccounts from "pages/BillingAccounts";
// provider pages
import DashboredProvider from "pages/DashboredProvider";
import CarCatalogProvider from "pages/CarCatalogProvider";
import RecivedOffersProvider from "pages/RecivedOffersProvider";
import RecivedOffersCar from "pages/RecivedOffersCar";
import ProUpgradePage from "pages/ProUpgradePage";
import ProPayPage from "pages/ProPayPage";
import ProSuccessPage from "pages/ProSuccessPage";
import PaymeReturnBridge from "pages/PaymeReturnBridge";
import PaymeCancelBridge from "pages/PaymeCancelBridge";
import PaymeCardBridge from "pages/PaymeCardBridge";
// shared
import CarFullProfile from "pages/CarFullProfile";

// admin
import AdminDashboard from "pages/admin/AdminDashboard";
import AdminUsers from "pages/admin/AdminUsers";
import AdminOffers from "pages/admin/AdminOffers";
import AdminCars from "pages/admin/AdminCars";
import AdminAuctions from "pages/admin/AdminAuctions";
import AdminBillingAccounts from "pages/admin/AdminBillingAccounts";

const ProjectRoutes = ({ currentUser, setCurrentUser, setGlobalCounters, setDealerCounters }) => {
  return useRoutes([
    // ===== PUBLIC =====
    {
      path: "/",
      element: <SignInDealer currentUser={currentUser} setCurrentUser={setCurrentUser} />,
    },
    { path: "/home", element: <Home /> },
    {
      path: "/payme/card/return",
      element: <PaymeCardBridge />,
    },
    {
      path: "/payme/card/cancel",
      element: <PaymeCardBridge status="cancel" />,
    },

    // ===== SHARED (Dealer + Provider) =====
    {
      element: (
        <RequireRole currentUser={currentUser} allow={[2, 3]} redirectTo="/">
          <Outlet />
        </RequireRole>
      ),
      children: [
        { path: "dashboard-provider/:id", element: <CarFullProfile currentUser={currentUser} /> },
        { path: "provider-cars/:id", element: <CarFullProfile currentUser={currentUser} /> },
        { path: "dealer-cars/:id", element: <CarFullProfile currentUser={currentUser} /> },
      ],
    },

    // ===== DEALER (user_type = 3) =====
    {
      element: (
        <RequireRole currentUser={currentUser} allow={[3]} redirectTo="/">
          <Outlet />
        </RequireRole>
      ),
      children: [
        {
          path: "dashboard-dealer",
          element: (
            <DashboredDealer currentUser={currentUser} setDealerCounters={setDealerCounters} />
          ),
        },
        {
          path: "dealer-cars",
          element: (
            <CarCatalogDealer
              currentUser={currentUser}
              setGlobalCounters={setDealerCounters} // כמו שהיה אצלך
            />
          ),
        },
        {
          path: "dealer-profile",
          element: <DealerProfile currentUser={currentUser} setCurrentUser={setCurrentUser} />,
        },
        {
          path: "my-offers",
          element: <OffersDealer currentUser={currentUser} setDealerCounters={setDealerCounters} />,
        },
        {
          path: "notifications",
          element: <NotificationsDealer currentUser={currentUser} />,
        },
        {
          path: "dealer-accounts",
          element: <BillingAccounts currentUser={currentUser} role="dealer" />,
        },
      ],
    },

    // ===== PROVIDER (user_type = 2) =====
    {
      element: (
        <RequireRole currentUser={currentUser} allow={[2]} redirectTo="/">
          <Outlet />
        </RequireRole>
        
      ),
      children: [
        {
          path: "dashboard-provider",
          element: <DashboredProvider currentUser={currentUser} setDealerCounters={setDealerCounters} />,
        },
     {
  path: "/pro-pay",
  element: <ProPayPage />,
},
{
  path: "/pro-pay/:pid",
  element: <ProPayPage />,
},
        {   
          path: "/pro/success",
          element: <ProSuccessPage />,
        },
        {
          path: "/pro/cancel",
          element: <div style={{ padding: 20 }}>התשלום בוטל</div>,
        },
     
        {
          path: "/pro-upgrade",
          element: <ProUpgradePage currentUser={currentUser} />,
        },
        {
          path: "provider-cars",
          element: <CarCatalogProvider currentUser={currentUser} setGlobalCounters={setGlobalCounters} />,
        },
        {
          path: "recived-offers",
          element: <RecivedOffersProvider currentUser={currentUser} />,
        },
        {
          path: "recived-offers/:id",
          element: <RecivedOffersCar currentUser={currentUser} />,
        },
        {
          path: "supplier-accounts",
          element: <BillingAccounts currentUser={currentUser} role="supplier" />,
        },
{
  path: "/payme/return",
  element: <PaymeReturnBridge />,
},
{
  path: "/payme/cancel",
  element: <PaymeCancelBridge />,
},

      ],
    },

    // ===== ADMIN (user_type = 1) =====
    {
      path: "admin",
      element: (
        <RequireAdmin currentUser={currentUser}>
          <Outlet />
        </RequireAdmin>
      ),
      children: [
        { index: true, element: <AdminDashboard /> },
        { path: "dashboard", element: <AdminDashboard /> },
        { path: "users/:kind", element: <AdminUsers /> },
        { path: "providers", element: <AdminUsers /> },
        { path: "offers", element: <AdminOffers /> },
        { path: "cars", element: <AdminCars /> },
        { path: "auctions", element: <AdminAuctions /> },
        { path: "auctions/:id", element: <CarFullProfile currentUser={currentUser} /> },
        { path: "received-offers", element: <RecivedOffersAdmin /> },
        { path: "import-ads", element: <ImportAdsAdmin /> },
        { path: "approved-deals", element: <AdminBillingAccounts currentUser={currentUser} /> },
    { path: "received-offers/:id", element: <RecivedOffersAdminCar /> }
      ],
    },

    // ===== 404 =====
    { path: "*", element: <NotFound /> },
  ]);
};

export default ProjectRoutes;
